import { connect } from 'react-redux';
import queryStringify from 'querystringify';
import {
  onChange,
  fetchBusinessTypes,
  showErrors,
  onSubmitSuccess,
  onSubmitFailure,
  onSubmit,
} from '../../actions';
import { LEAD_CREATION_URL } from '../../constants';
import BusinessInfo from '../../components/business-info';
import validate from '../../helpers/validation/validations';
import safeFetch from '../../helpers/safe-fetch';
import { getFormSubmitValues } from '../../helpers/get-form-submit-values';

import {
  State,
  BusinessInfo as BusinessInfoType,
  Countries,
  DraftServiceResponse,
} from '../../types';
import {
  trackEvent,
  trackBloodhoundEvent,
  trackGoogleConversionAndFB,
} from '../../helpers/tracking';

const mapStateToProps = (state: State) => ({
  businessTypes: [],
  ...state.businessInfo,
  ...state.businessTypes,
});

const mapDispatchToProps = (dispatch: Function) => ({
  update: (data: Object) => dispatch(onChange(data)),
  fetchBusinessTypes: async () => dispatch(await fetchBusinessTypes()),
  onSubmit: (props: BusinessInfoType) => {
    let { utm_campaign }: any = queryStringify.parse(decodeURI(location.search));
    if (!utm_campaign) {
      utm_campaign = !!document.referrer ? 'Other' : 'Direct';
    }
    const formSubmitValues = getFormSubmitValues(props);
    const validationErrors = validate(formSubmitValues);
    dispatch(showErrors(validationErrors));
    if (Object.keys(validationErrors).length) {
      dispatch(showErrors(validationErrors));
      trackEvent('web2lead-submit', 'validation-error', Object.keys(validationErrors).join(','));
      return;
    }

    dispatch(onSubmit());
    safeFetch(LEAD_CREATION_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'x-csrf-token': window.csrf_token,
      },
      body: JSON.stringify(formSubmitValues),
    })
      .then((res: DraftServiceResponse) => {
        trackGoogleConversionAndFB();
        dispatch(onSubmitSuccess(res));
      })
      .catch(e => {
        trackBloodhoundEvent('signup-submit', 'lead_error');
        dispatch(onSubmitFailure());
      });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusinessInfo);
